import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIInput = _resolveComponent("UIInput")!
  const _component_UITextArea = _resolveComponent("UITextArea")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b('requisites'))
  }, [
    _createElementVNode("h4", {
      class: _normalizeClass(_ctx.b('requisites-title'))
    }, "Банковские реквизиты", 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('requisites-content'))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('field'))
      }, [
        _createElementVNode("h4", {
          class: _normalizeClass(_ctx.b('field-title'))
        }, _toDisplayString(_ctx.$t("Название*")), 3),
        _createVNode(_component_UIInput, {
          view: "light",
          modelValue: _ctx.bankRequisite.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bankRequisite.name) = $event)),
          disabled: ""
        }, null, 8, ["modelValue"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('field'))
      }, [
        _createElementVNode("h4", {
          class: _normalizeClass(_ctx.b('field-title'))
        }, _toDisplayString(_ctx.$t("Номер расчетного счета*")), 3),
        _createVNode(_component_UIInput, {
          view: "light",
          modelValue: _ctx.bankRequisite.account_number,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bankRequisite.account_number) = $event)),
          disabled: ""
        }, null, 8, ["modelValue"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('field'))
      }, [
        _createElementVNode("h4", {
          class: _normalizeClass(_ctx.b('field-title'))
        }, _toDisplayString(_ctx.$t("Номер корреспондентского счета*")), 3),
        _createVNode(_component_UIInput, {
          view: "light",
          modelValue: _ctx.bankRequisite.correspondent_account,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bankRequisite.correspondent_account) = $event)),
          disabled: ""
        }, null, 8, ["modelValue"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('field'))
      }, [
        _createElementVNode("h4", {
          class: _normalizeClass(_ctx.b('field-title'))
        }, _toDisplayString(_ctx.$t("Банковский идентификационный код (БИК)*")), 3),
        _createVNode(_component_UIInput, {
          view: "light",
          modelValue: _ctx.bankRequisite.bank_identification_code,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bankRequisite.bank_identification_code) = $event)),
          disabled: ""
        }, null, 8, ["modelValue"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('field'))
      }, [
        _createElementVNode("h4", {
          class: _normalizeClass(_ctx.b('field-title'))
        }, _toDisplayString(_ctx.$t("Полное наименование банка*")), 3),
        _createVNode(_component_UIInput, {
          view: "light",
          modelValue: _ctx.bankRequisite.bank_name,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.bankRequisite.bank_name) = $event)),
          disabled: ""
        }, null, 8, ["modelValue"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('field'))
      }, [
        _createElementVNode("h4", {
          class: _normalizeClass(_ctx.b('field-title'))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("Идентификационный номер")) + " ", 1),
          _hoisted_1,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("налогоплательщика (ИНН)*")), 1)
        ], 2),
        _createVNode(_component_UIInput, {
          view: "light",
          modelValue: _ctx.bankRequisite.inn,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bankRequisite.inn) = $event)),
          disabled: ""
        }, null, 8, ["modelValue"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('field'))
      }, [
        _createElementVNode("h4", {
          class: _normalizeClass(_ctx.b('field-title'))
        }, _toDisplayString(_ctx.$t("Код причины постановки на учет (КПП)*")), 3),
        _createVNode(_component_UIInput, {
          view: "light",
          modelValue: _ctx.bankRequisite.registration_reason_code,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bankRequisite.registration_reason_code) = $event)),
          disabled: ""
        }, null, 8, ["modelValue"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('field'))
      }, [
        _createElementVNode("h4", {
          class: _normalizeClass(_ctx.b('field-title'))
        }, "Примечание", 2),
        _createVNode(_component_UITextArea, {
          view: "light",
          disabled: "",
          rows: "4",
          placeholder: "Добавьте комментарий при необходимости",
          modelValue: _ctx.bankRequisite.note,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.bankRequisite.note) = $event))
        }, null, 8, ["modelValue"])
      ], 2)
    ], 2)
  ], 2))
}